import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import JqxLoader from "jqwidgets-scripts/jqwidgets-react-tsx/jqxloader";
import JqxDateTimeInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxdatetimeinput";
import * as Util from "../../utils/util.js";
import BasicBackBoard from "../../components/BasicBackBoard.js";
import AutoCompleteInputTextField from "../../components/AutoCompleteInputTextField.js";

import PqGrid from "../../components/PqGrid.js";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#ABADB3",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white !important",
      borderRadius: "2px",
      fontFamily: `"Malgun Gothic", "맑은 고딕", AppleSDGothicNeo-Light, sans-serif`,
      "& fieldset": { color: "#ABADB3" },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0, 176, 246, 1)",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "13px",
      paddingLeft: "6px",
      paddingRight: "6px",
    },
    "& .MuiIconButton-root": {
      padding: "1px",
      margin: "0px 2px",
    },
  },
})(TextField);

const useStyles = makeStyles(() => ({
  root: { display: "flex", flex: 1, width: "100%" },

  spanVerticalAlign: {
    lineHeight: "26px",
  },

  clearIcon: {
    position: "relative",
    float: "right",
    left: "-620px",
    zIndex: 2,
  },

  cellStyle: { border: "1px solid" },

  textField: {
    width: "200px",
  },

  numberTextField: {
    fontSize: "14px",
    width: "60px",
    height: "26px",
  },

  span: {
    display: "inline-block",
    paddingTop: "3px",
    fontFamily: `"Malgun Gothic", "\B9D1\C740 \ACE0\B515", AppleSDGothicNeo-Light, sans-serif`,
    color: "#4e545f",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "1.5em",
    whiteSpace: "nowrap",
    overflowX: "clip",
    marginLeft: "20px",
  },

  datePicker: {
    width: "165px",
    margin: 0,
    padding: 0,
    fontSize: "1px",
  },

  header: {
    width: "100%",
    marginTop: "10px",
    height: "50px",
    fontFamily: "NanumGothic",
  },

  footer: {
    position: "fixed",
    width: "100%",
    height: "35px",
    backgroundColor: "#DADADA",
    color: "white",
    bottom: 0,
  },
}));

let searchParam;

function Menu8(props) {
  const classes = useStyles();
  const myLoader = useRef();
  const myCalendarF = useRef();
  const myCalendarT = useRef();
  const [masterList, setMasterList] = useState([]);
  const [detailList, setDetailList] = useState([]);
  const [excelList, setExcelList] = useState([]);
  const [culture, setCulture] = useState("ko-KR");
  const refSearchSellCust = useRef();
  const refSearchVenCust = useRef();

  const refMasterPqGrid = useRef();
  const refDetailPqGrid = useRef();
  const [onDisplay, setOnDisplay] = useState(false);

  useEffect(() => {
    if (myCalendarF.current) {
      myCalendarF.current.setDate(Util.getFirstDayOfMonth());
    }
  }, []);

  useEffect(() => {
    if (props.name === props.selected) {
      setOnDisplay(true);
    } else {
      setOnDisplay(false);
    }
  }, [props.name, props.selected]);

  const masterColumnLayout = [
    {
      title: "수요가",
      dataIndx: "SELL_CUST_NAME",
      width: 195,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
  ];

  const detailColumnLayout = [
    {
      title: "정산일",
      dataIndx: "ACCOUNT_DATE",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "text-align": "center" },
      merge: true,
    },
    {
      title: "정산번호",
      dataIndx: "ACCOUNT_NO",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "text-align": "center" },
      merge: true,
    },
    {
      title: "출고번호",
      dataIndx: "SHIP_NO",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "text-align": "center" },
      merge: true,
    },
    {
      title: "매출번호",
      dataIndx: "SHIP_NO",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "text-align": "center" },
      merge: true,
    },
    {
      title: "인도조건",
      dataIndx: "TRANS_TYPE_NAME",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "운송사",
      dataIndx: "TRANS_CUST_NAME",
      width: 170,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "차량번호",
      dataIndx: "TRANS_CAR_NO",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "매출유형",
      dataIndx: "TRANS_NAME",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "중량",
      dataIndx: "WEIGHT",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0.0",
      summary: { type: "sum" },
    },
    {
      title: "운송단가",
      dataIndx: "TRANS_BASE_PRICE",
      width: 120,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      render: function (ui) {
        return Util.formatNumber(parseFloat(ui.cellData), "#,##0.0#");
      },
    },
    {
      title: "운송금액",
      dataIndx: "TRANS_PRICE",
      width: 120,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "사급업체",
      dataIndx: "VEN_CUST_NAME",
      width: 190,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "착지",
      dataIndx: "DLV_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
  ];

  const loadItem = () => {
    myLoader.current.open();

    searchParam = {
      isOutSider: Util.isOutsider(),
      dateF: new Date(
        myCalendarF.current.getDate() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10)
        .replaceAll("-", ""),
      dateT: new Date(
        myCalendarT.current.getDate() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10)
        .replaceAll("-", ""),
      userId: window.sessionStorage.getItem("user_id"),
      myCustCd: window.sessionStorage.getItem("workplace_cd"),
      sellCustCd: refSearchSellCust.current.get().code,
      sellCustName: refSearchSellCust.current.get().input,
      venCustCd: refSearchVenCust.current.get().code,
      venCustName: refSearchVenCust.current.get().input,
    };

    axios
      .get(Util.getBaseUrl() + "Menu8/retrieve", {
        params: searchParam,
      })
      .then((response) => {
        if (response.data.code === "0") {
          myLoader.current.close();
          let res = response.data;
          setMasterList(res.master);
        } else {
          alert(
            "조회된 내역이 없습니다.",
            myLoader.current.close(),
            setMasterList([]),
            setDetailList([]),
            setExcelList([])
          );
        }
      })
      .catch((e) => {
        console.error(e); // 에러표시
        myLoader.current.close();
      });
  };

  const onMasterRetrieve = () => {
    refMasterPqGrid.current?.setSelection(0, 0);
  };

  const masterRowClickHandler = (e) => {
    myLoader.current.open();

    let sellCustCd = e.SELL_CUST_CD;

    if (sellCustCd == null) {
      sellCustCd = " ";
    }
    searchParam["sellCustCd"] = sellCustCd;

    axios
      .get(Util.getBaseUrl() + "Menu8/retrieve", {
        params: searchParam,
      })
      .then((response) => {
        if (response.data.code === "0") {
          myLoader.current.close();
          let res = response.data;
          setDetailList(res.detail);
        } else {
          alert(
            "조회된 내역이 없습니다.",
            myLoader.current.close(),
            setDetailList([])
          );
        }
      })
      .catch((e) => {
        console.error(e); // 에러표시
        myLoader.current.close();
      });
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <div style={{ flex: "0 0 auto" }}>
          <BasicBackBoard>
            <div className="d-flex p-1 pb-0 search-form-div">
              <div>
                <span className={classes.span}>정산일</span>
              </div>
              <div className="ms-2" onKeyDown={Util.enterToFocusMove}>
                <JqxDateTimeInput
                  textAlign="center"
                  ref={myCalendarF}
                  animationType={"none"}
                  formatString={"yyyy-MM-dd"}
                  culture={culture}
                  width={130}
                  height={"26px"}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div onKeyDown={Util.enterToFocusMove}>
                <JqxDateTimeInput
                  textAlign="center"
                  ref={myCalendarT}
                  animationType={"none"}
                  culture={culture}
                  formatString={"yyyy-MM-dd"}
                  width={130}
                  height={"26px"}
                />
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>수요가 </span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchSellCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>사급업체</span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchVenCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div className="d-flex" style={{ marginLeft: "68px" }}>
                <Button
                  className="d-btn primary"
                  onClick={() => loadItem()}
                  variant="contained"
                >
                  조회
                </Button>
                <Button
                  className="d-btn primary"
                  onClick={() =>
                    refDetailPqGrid.current?.exportExcel("운송비정산현황")
                  }
                  variant="contained"
                >
                  엑셀
                </Button>
              </div>
            </div>
          </BasicBackBoard>
        </div>
        <div className={classes.root}>
          <JqxLoader ref={myLoader} width={100} height={60} />
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              overflowX: "hidden",
              boxSizing: "border-box",
              marginRight: "4px",
            }}
          >
            <PqGrid
              name={props.name}
              ref={refMasterPqGrid}
              width={"254px"}
              columns={masterColumnLayout}
              dataModel={masterList}
              display={onDisplay}
              useGroupingPanel={false}
              onSetData={onMasterRetrieve}
              onRowClick={masterRowClickHandler}
            />
          </div>
          <div style={{ flex: 1 }}>
            <PqGrid
              name={props.name}
              ref={refDetailPqGrid}
              width={"100%"}
              columns={detailColumnLayout}
              dataModel={detailList}
              display={onDisplay}
              retrieve={loadItem}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Menu8);
